<template>
    <div class="row">
        <div class="col-xs-12" v-if="!isEmbed && !loggedIn && requireLoggedIn">
            <div class="alert alert-warning" role="alert">
                <span v-html="$_locale('You must be %slogged in%s to make a reservation.', true, ['<a data-toggle=\'modal\' id=\'loginModalLink\' href=\'#myModal\'>', '</a>'])"></span>
                <span v-html="$_locale('If you do not have credentials, you can %sregister here%s.', true, ['<a href=\'?action=registration\'>','</a>'])"></span>
            </div>
        </div>
        <div class="col-xs-12" v-if="isInvalidDate(date)">
            <div class="alert alert-warning" role="alert">
                {{ $_locale('The reservations are not open for the chosen day.') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            date: 'reservations/date',
            isInvalidDate: 'reservations/isInvalidDate',
            loggedIn: 'common/loggedIn',
            requireLoggedIn: 'common/requireLoggedIn',
            isEmbed: 'common/isEmbed',
        })
    }
}
</script>